import { ScreenShareApis, StartAudioMixRecordConfig } from "@core/ability";

interface IGetLocalAudioTypeRes {
  type: string;
  data?: StartAudioMixRecordConfig;
}
const getLocalAudioType = async () => {
  const defaultRes: IGetLocalAudioTypeRes = {
    type: "webrtc",
  };
  try {
    const listRes = await ScreenShareApis.getAvailableMicrophones();
    if (listRes.code !== 0) {
      throw new Error(listRes.msg);
    } else {
      const defaultMic = listRes.data.find((item) => item.isDefault);
      return {
        type: "localLink",
        data: {
          micInfo: defaultMic,
        } as StartAudioMixRecordConfig,
      };
    }
  } catch (error) {
    console.log("使用传屏sdk获取麦克风列表失败，使用webrtc进行本地录制");
    return defaultRes;
  }
};

export default getLocalAudioType;
